import {createStore, applyMiddleware, compose} from "redux";
import {routerMiddleware} from "react-router-redux";

import rootReducer from "../reducers/rootReducer";
import createHistory from "history/createBrowserHistory";
import thunk from "redux-thunk";

export const history = createHistory();

const enhancers = [];
const middleware = [
  thunk,
  routerMiddleware(history)
];

if(process.env.NODE_ENV === "development" || process.env.REACT_APP_SHOW_STACKTRACE) {
  const devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__;

  if (typeof devToolsExtension === "function") {
    enhancers.push(devToolsExtension())
  }
}

const composedEnhancers = compose(
  applyMiddleware(...middleware),
  ...enhancers
);

export default function configureStore() {
  return createStore(
    rootReducer,
    composedEnhancers,
  );
}





// WEBPACK FOOTER //
// ./src/store/configureStore.js